<template>
  <div class="InnerPY_wrapper">
    <div class="title">
      <div
        :class="[`title_con`, `${currentIndex == index ? 'active' : ''}`]"
        v-for="(item, index) in dataList"
        :key="index"
        @click="toggleActive(index)"
      >
        {{ item.propertyName }}
      </div>
    </div>
    <template>
      <div class="content" v-for="(item, index) in liabilitys" :key="index">
        <div class="con_header">
          <div class="header-con">{{ item.title }}</div>
          <div class="header-con">{{ item.amount }}</div>
        </div>
        <div class="con_detail">{{ item.content }}</div>
      </div>
    </template>
  </div>
</template> 

<script>
import "./InnerPolicyDetail.less";
import { getProductDetail } from "../../api/api";
export default {
  name: "InnerPolicyDetail",
  data() {
    return {
      liabilitys: [],
      dataList: [],
      currentIndex: 0, // 当前方案的索引，默认显示A方案
    };
  },
  methods: {
    async getData() {
      const { product } = await getProductDetail({
        pid: this.$route.query.productId,
      });
      console.log(product);
      const { insurances } = product
      const dataList = insurances[0].insuranceAmount
      this.dataList = dataList
      this.liabilitys = dataList[this.currentIndex].liabilitys
    },
    // 切换方案
    toggleActive(index) {
      this.currentIndex = index;
      console.log(index)
      this.liabilitys = this.dataList[index].liabilitys
    },
  },

  mounted() {
    this.getData();
  },
};
</script>

<style>
</style>